export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Devise"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Créer un rapport"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Résultat de la devise"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Télécharger"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Feuille"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Format de fichier autorisé - xlsx"])}
}